import React, { useState } from "react";
import WeekSelector from "../../../components/WeekSelector";
import { useSiteContext } from "../../../SiteContext";
import PaycorManager from "../../../managers/PaycorManager";
import "./ManualPaycor.css";
import PageWrapper from "../../../components/PageWrapper";
import Colors from '../../../styles/Colors.json';

interface ManualPaycorProps {
  setError: (error: string | null) => void;
}

const ManualPaycor: React.FC<ManualPaycorProps> = ({ setError }) => {
  const { setLoading, year, startDate, endDate, week, createPopup, translator } = useSiteContext();
  const [userInput, setUserInput] = useState<string>("");

  const handleDownloadClick = async () => {
    createPopup('Download Initiated', `Getting Paycor Files for week ${week}, ${year}.`);
    setLoading(true);

    // Remove all whitespace and ensure each number is 5 digits long
    const cleanedInput = userInput
      .replace(/\s+/g, '') // Remove whitespace
      .split(',') // Split the input by commas
      .map(id => id.padStart(5, '0')) // Add leading zeros to each ID to make it 5 digits
      .join(','); // Join the IDs back into a comma-separated string

      console.log(startDate, endDate, cleanedInput);

    // Assuming you're calling this method to download files
    const { file1URL, file2URL } = await PaycorManager.manualDownloadPaycorFiles(startDate, endDate, cleanedInput);

    // Now, call createPopup with the URLs
    createPopup("Download Links:", `Payroll File: ${file1URL}\nSupervisor File: ${file2URL}`);

    
    setLoading(false);
  };

  const handleTextChange = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
    setUserInput(event.target.value);
  };

  return (
    <PageWrapper title={translator.translate("manualPaycor")} backgroundColor={Colors.White} weekSelector={true}>
      
      {/* Large text box for user input */}
      <div className="input-container">
          <label className="input-label">Enter employee IDs here...</label>
          <textarea
            value={userInput}
            onChange={handleTextChange}
            rows={8}  // Adjust rows for large textarea size
            placeholder="Ex. 01234,56789,10111"
          />
        </div>

        <div className="downloadable-data">
          <button className="download-btn" onClick={handleDownloadClick}>
            {translator.translate("DownloadPaycorForWeek")} {week} / {year}
          </button>
        </div>
    </PageWrapper>
  );
};

export default ManualPaycor;
